import { Component, OnInit, Input, Optional, Self, ElementRef } from '@angular/core';
import { MatLegacyFormFieldControl as MatFormFieldControl } from '@angular/material/legacy-form-field';
import { ControlValueAccessor, UntypedFormGroup, NgControl, UntypedFormBuilder, UntypedFormArray, UntypedFormControl } from '@angular/forms';
import { Subject } from 'rxjs';
import { coerceBooleanProperty } from '@angular/cdk/coercion';
import { NumberCoordinate, LotteryParamOption, Point } from '../../../lottoloca-commom/lottery-modex';
import { FocusMonitor } from '@angular/cdk/a11y';
import { List } from 'linqts';

@Component({
  selector: 'lottery-param-options',
  templateUrl: './lottery-param-options.component.html',
  styleUrls: ['./lottery-param-options.component.css'],
  providers: [
    
    { provide: MatFormFieldControl, useExisting: LotteryParamOptionsComponent },
 
  ],
  host: {
    '[class.floating]': 'shouldLabelFloat',
    '[id]': 'id',
    '[attr.aria-describedby]': 'describedBy',
  }
 })
export class LotteryParamOptionsComponent implements MatFormFieldControl<LotteryParamOption[]>, ControlValueAccessor, OnInit {

  static nextId = 0;
  parts: UntypedFormGroup;
  stateChanges = new Subject<void>();
  focused = false;
  //ngControl = null;
  errorState = false;
  controlType = 'lottery-param-options';
  id = `lottery-param-options-${LotteryParamOptionsComponent.nextId++}`;
  describedBy = '';
  _isReady: boolean = false;
  _items :UntypedFormArray;

  private onChange: (value: LotteryParamOption[]) => void;
  _value: LotteryParamOption[];


  constructor(@Optional() @Self() public ngControl: NgControl,
    fb: UntypedFormBuilder,
    private fm: FocusMonitor,
    private elRef: ElementRef<HTMLElement>,
    private formBuilder: UntypedFormBuilder) {

    // Setting the value accessor directly (instead of using
    // the providers) to avoid running into a circular import.
    if (this.ngControl != null) { this.ngControl.valueAccessor = this; }

    this.parts = fb.group({
      textValue: ''
    });

    fm.monitor(elRef.nativeElement, true).subscribe(origin => {
      this.focused = !!origin;
      this.stateChanges.next();
    });
  }



  public changeDate() {

    this.onChange(this.value);
  }

  writeValue(obj: LotteryParamOption[]): void {

    this.value = obj;
  }

  public registerOnChange(onChange: (value: LotteryParamOption[]) => void): void {
    this.onChange = onChange;
  }
  registerOnTouched(fn: any): void {
    //throw new Error("Method not implemented.");
  }
  setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled;

    if (isDisabled) {
      this.parts.get("textValue").disable();
    }
    else {
      this.parts.get("textValue").enable();
    }
  }


  get empty() {
    const { value: { textValue } } = this.parts;

    return !textValue;
  }

  get shouldLabelFloat() { return this.focused || !this.empty; }

  @Input()
  get placeholder(): string { return this._placeholder; }
  set placeholder(value: string) {
    this._placeholder = value;
    this.stateChanges.next();
  }
  private _placeholder: string;

  @Input()
  get required(): boolean { return this._required; }
  set required(value: boolean) {
    this._required = coerceBooleanProperty(value);
    this.stateChanges.next();
  }
  private _required = false;

  @Input()
  get disabled(): boolean { return this._disabled; }
  set disabled(value: boolean) {
    this._disabled = coerceBooleanProperty(value);
    this.stateChanges.next();
  }
  private _disabled = false;

  @Input()
  get value(): LotteryParamOption[] | null {


    return this._value;

  }

  set value(value: LotteryParamOption[] | null) {

    if (value == null) {
      this._value = [];
    }
    else {

      this._value = value;
    }

    this.updateGui();

    this.stateChanges.next();
  }

  ngOnDestroy() {
    this.stateChanges.complete();
    this.fm.stopMonitoring(this.elRef.nativeElement);
  }

  setDescribedByIds(ids: string[]) {
    this.describedBy = ids.join(' ');
  }

  onContainerClick(event: MouseEvent) {
    if ((event.target as Element).tagName.toLowerCase() != 'input') {
      this.elRef.nativeElement.querySelector('input')!.focus();
    }
  }



  //******************************* */

  public _indexes: any[] = [];

  public updateGui(): any {

    let items: Array<UntypedFormGroup> = [];


    this.value.forEach(x => {

      let newForm = this.createItem(x.description, x.coordinates);

      items.push(newForm);
    });


    this.orderForm = this.formBuilder.group({
      items: this.formBuilder.array(items)
    });

    this._items = this.orderForm.get('items') as UntypedFormArray;

    this.orderForm.
      valueChanges
      .subscribe(() => {


        let items = this.orderForm.get('items') as UntypedFormArray;

        this.propagateChanges();
      }
      );
  }

  public showValue() {
 
  }

  public onChangeCoordinate(X: number, Y: number, value: any) {


  }

  public addPoint() {

    this.addItem();
  }

  addItem(): void {

    let items = this.orderForm.get('items') as UntypedFormArray;

    items.push(this.createItem('', []));
  }

  public propagateChanges() {

    let items = this.orderForm.get('items') as UntypedFormArray;

    this._value = items.value;

    if (this.onChange != null) {
      this.onChange(this.value)
    }
  }



  public showValues() {
    
  }

  public createItem(description, coordinates: Point[]): UntypedFormGroup {


    if(coordinates == null)
    {
    coordinates = [];
    }
    let form = this.formBuilder.group({
      description: description,
      coordinates: new UntypedFormControl(coordinates)
    });

    return form;

  }

  orderForm: UntypedFormGroup;


  ngOnInit() {
    this.updateGui();
  }

    
  public remove(index:number) {

    this._items = this.orderForm.get("items") as UntypedFormArray;

    this._items.removeAt(index);

  }
}
